export enum QuestId {
  CameraCabinet = 'camera_cabinet',
  Camera = 'camera',
  KPK = 'pda',
  Oscilloscope = 'oscilloscope_1',
  Books = 'books',
  Flowers = 'flowers',
  Guardians = 'knot_harlan',
  KnotKsarat = 'knot_ksarat',
  KnotAsterion = 'knot_asterion',
  Columns = 'columns',
  Cipher = 'cipher',
  Trees = 'forest',
  Hottei = 'hottei',
  Constellation = 'constellation',
  Nightsong = 'nightsong',
  EyeGate = 'altar_eye',
  Eye = 'eye',
  Split = 'split',
  Not = 'not',
  Rhomb = 'rhomb',
  Spiral = 'spiral',
  String = 'string',
  TapTap = 'TapTap',
  Access = 'access',
  Hotey = 'hotey',
  Nameless = 'question_mark',
  Lock = 'lock',
  Riddle = 'riddle',
  Numbers = 'numbers',
  Dots = 'dots',
  CameraPanelka = 'camera_panelka',
  KnotVira = 'knot_vira',
  Panelka = 'panelka',
  Next = 'next',
  Message = 'message',
  Elements = 'elements',
  KnotRuviy = 'knot_ruviy',
  Expansion = 'expansion',
  Counting = 'counting',
  Fragmentation = 'fragmentation',
  Switch = 'switch',
  CameraOscilloscope = 'camera_oscilloscope',
  Changes = 'changes',
  KnotMorian = 'knot_morian',
  Disk = 'spheres',
  Oscilloscope02 = 'oscilloscope_2',
  Duality = 'duality',
  KnotAilin = 'knot_ailin',
  Quietude = 'quietude',
  Oscilloscope03 = 'oscilloscope_3',
  Volume = 'volume',
  NotQuest = 'not_quest',
  Mirror = 'mirror',
  Shadow = 'shadow',
  Chain = 'chain',
  CameraMirror = 'camera_mirror',
  Box = 'box',
  Void = 'void',
  Decrypt = 'decrypt',
  KnotSafaris = 'knot_safaris',
  KnotFragments = 'knot_fragments',
  Curve = 'curve',
  Lights = 'lights',
  Cassete = 'cassete',
  Moment = 'moment',
  Grid = 'grid',
  Gap = 'gap',
  Order = 'order',
  Playback = 'playback',
  Assembly = 'assembly',
  Whisper = 'whisper',
  Hollow = 'hollow',
  Resolve = 'resolve',
  Ring = 'ring',
  Seal = 'seal',
  Error = 'error',
  Call = 'call'
}
